import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: ${props => props.theme.space(3)};
  justify-content: flex-start;

  ${mediaMin.smallBreakpoint`
    justify-content: space-between;
  `};
`;

export const MaxValues = styled.span`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(1)};
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.unisystem.calendar.maxStay.color};
`;
